import { ActionSheet } from '../add-edit/ActionSheet';
import { BomToolbarButton } from './BomToolbarButton';
import { BulkEditAddButton } from '../bulk-edit/BulkEditAddButton';
import { BulkEditTheatre } from '../bulk-edit/BulkEditTheatre';
import { ColumnHideSheet } from '../column-hide/ColumnHideSheet';
import { CopyButton } from '../copy-paste/components/CopyButton';
import { DeletePrompt } from './DeletePrompt';
import { EmissionFactorButton } from '../../../emission-factor/components/EmissionFactorButton';
import { ExcelExportButton } from './ExcelExportButton';
import { FilterPillBar } from '../filters/FilterPillBar';
import { FilterSheet } from '../filters/FilterSheet';
import { HideInactiveRowsButton } from './HideInactiveRowsButton';
import { LoadingIndicator } from '../../../../shared/components/TableLoadingIndicator';
import { LockButton } from './LockButton';
import { PasteButton } from '../copy-paste/components/PasteButton';
import { RefreshConnectedButton } from './RefreshConnectedButton';
import { ResetConnectedButton } from './ResetConnectedButton';
import { SearchBar } from './SearchBar';
import { ToggleExpandButton } from './ToggleExpandButton';
import { UnlockButton } from './UnlockButton';
import styled from '@emotion/styled';
import { theme } from '../../../../shared/styles/core/theme';
import { tokens } from '../../../../shared/styles/core/tokens';
import { useAuth } from '../../../auth/state/auth.state';
import { CompactToggle } from './CompactToggle';

export const TableToolbar = () => {
   const { canEdit, canManageEmissionFactors } = useAuth();

   return (
      <StyledOuterToolbarDiv>
         <ActionSheet />
         <LoadingIndicator />
         <StyledInnerToolbarDiv>
            <div>
               <ToggleExpandButton />
               {canEdit && <DeletePrompt />}
               {canEdit && <LockButton />}
               {canEdit && <UnlockButton />}
               {canEdit && <RefreshConnectedButton />}
               {canEdit && <CopyButton />}
               {canEdit && <PasteButton />}
               {canEdit && <BulkEditTheatre />}
               {canEdit && <BulkEditAddButton />}
               {canEdit && <ResetConnectedButton />}
               {canEdit && <BomToolbarButton />}
               {canManageEmissionFactors && <EmissionFactorButton />}
               <HideInactiveRowsButton />
            </div>
            <StyledRightToolbarDiv>
               <SearchBar />
               <FilterSheet />
               <ColumnHideSheet />
               <CompactToggle />
               <ExcelExportButton />
            </StyledRightToolbarDiv>
         </StyledInnerToolbarDiv>
         <FilterPillBar />
      </StyledOuterToolbarDiv>
   );
};

const StyledRightToolbarDiv = styled.div`
   display: flex;
   align-items: center;
`;

const StyledOuterToolbarDiv = styled.div`
   background-color: ${theme.colors.bg.primary};
   padding: ${tokens.space.lg} ${tokens.space.lg} ${tokens.space.lg} ${tokens.space.lg};
`;

const StyledInnerToolbarDiv = styled.div`
   display: flex;
   justify-content: space-between;
`;